import React from 'react';
import {Link} from 'react-router-dom';
import {StyleSheet, css} from 'aphrodite';

import {CONTACT_DETAILS, FAQ_DATA} from '../data/yabathoLegalContent';

export default function Support() {
  return (
    <main className={css(styles.page)}>
      <section className={css(styles.hero)}>
        <div className={css(styles.logoMark)}>YB</div>
        <p className={css(styles.kicker)}>YaBatho Support</p>
        <h1 className={css(styles.title)}>Help & Support</h1>
        <p className={css(styles.subtitle)}>
          Get help with your YaBatho account, orders, payments, delivery,
          pick-up, dine-in reservations, or account deletion requests.
        </p>
      </section>

      <section className={css(styles.card)}>
        <div className={css(styles.grid)}>
          <article className={css(styles.panel)}>
            <h2>Contact support</h2>
            <p>
              Email us and include your name, registered email address, phone
              number, and order number where relevant.
            </p>
            <a
              className={css(styles.primaryButton)}
              href={`mailto:${CONTACT_DETAILS.supportEmail}`}>
              Email support
            </a>
          </article>

          <article className={css(styles.panel)}>
            <h2>Support details</h2>
            <dl className={css(styles.details)}>
              <div>
                <dt>Email</dt>
                <dd>{CONTACT_DETAILS.supportEmail}</dd>
              </div>
              <div>
                <dt>WhatsApp</dt>
                <dd>{CONTACT_DETAILS.whatsapp}</dd>
              </div>
              <div>
                <dt>Address</dt>
                <dd>{CONTACT_DETAILS.address}</dd>
              </div>
            </dl>
          </article>
        </div>

        <div className={css(styles.notice)}>
          <h2>Account and data requests</h2>
          <p>
            To request account deletion or personal data assistance, use the
            account deletion page or email support directly.
          </p>
          <Link className={css(styles.secondaryButton)} to="/delete-account">
            Delete account request
          </Link>
        </div>

        <section className={css(styles.faq)}>
          <h2>Common questions</h2>
          {FAQ_DATA.map(item => (
            <article key={item.question} className={css(styles.faqItem)}>
              <h3>{item.question}</h3>
              <p>{item.answer}</p>
            </article>
          ))}
        </section>

        <div className={css(styles.actions)}>
          <Link className={css(styles.secondaryButton)} to="/privacy-policy">
            Privacy Policy
          </Link>
          <Link className={css(styles.secondaryButton)} to="/home">
            Go home
          </Link>
        </div>
      </section>
    </main>
  );
}

const styles = StyleSheet.create({
  page: {
    minHeight: '100vh',
    backgroundColor: '#FFFDF7',
    color: '#0F3D2E',
    fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
    padding: '32px 18px 96px',
    boxSizing: 'border-box',
  },
  hero: {
    maxWidth: 920,
    margin: '0 auto 22px',
    backgroundColor: '#0F3D2E',
    color: '#ffffff',
    borderRadius: 28,
    padding: '34px',
    border: '1px solid rgba(201, 161, 74, 0.45)',
    boxShadow: '0 22px 50px rgba(15, 61, 46, 0.16)',
  },
  logoMark: {
    width: 58,
    height: 58,
    borderRadius: '50%',
    backgroundColor: '#F4EBD8',
    color: '#C9A14A',
    border: '2px solid #C9A14A',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 900,
    marginBottom: 18,
  },
  kicker: {
    margin: '0 0 8px',
    color: '#C9A14A',
    fontSize: 12,
    fontWeight: 900,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  title: {
    margin: 0,
    color: '#ffffff',
    fontSize: 42,
    lineHeight: 1.05,
    fontWeight: 900,
  },
  subtitle: {
    maxWidth: 760,
    margin: '14px 0 0',
    color: '#F4EBD8',
    fontSize: 16,
    lineHeight: 1.7,
  },
  card: {
    maxWidth: 920,
    margin: '0 auto',
    backgroundColor: '#ffffff',
    border: '1px solid #E6D8BE',
    borderRadius: 24,
    padding: 28,
    boxShadow: '0 12px 34px rgba(30, 30, 30, 0.06)',
    boxSizing: 'border-box',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: 16,
  },
  panel: {
    backgroundColor: '#FFFDF7',
    border: '1px solid #F1E7D2',
    borderRadius: 18,
    padding: 18,

    h2: {
      margin: '0 0 10px',
      color: '#0F3D2E',
    },

    p: {
      color: '#6E6254',
      lineHeight: 1.7,
    },
  },
  details: {
    margin: 0,

    div: {
      borderBottom: '1px solid #F1E7D2',
      padding: '10px 0',
    },

    dt: {
      color: '#8C8170',
      fontSize: 12,
      fontWeight: 900,
      textTransform: 'uppercase',
      letterSpacing: 0.6,
    },

    dd: {
      margin: '5px 0 0',
      color: '#0F3D2E',
      fontWeight: 800,
      lineHeight: 1.5,
    },
  },
  notice: {
    marginTop: 18,
    border: '1px solid #E6D8BE',
    borderRadius: 18,
    backgroundColor: '#F4EBD8',
    padding: 18,

    h2: {
      margin: '0 0 8px',
      color: '#0F3D2E',
    },

    p: {
      color: '#6E6254',
      lineHeight: 1.7,
    },
  },
  faq: {
    marginTop: 24,

    h2: {
      margin: '0 0 12px',
      color: '#0F3D2E',
    },
  },
  faqItem: {
    borderTop: '1px solid #F1E7D2',
    padding: '14px 0',

    h3: {
      margin: '0 0 6px',
      color: '#0F3D2E',
      fontSize: 17,
    },

    p: {
      margin: 0,
      color: '#6E6254',
      lineHeight: 1.7,
    },
  },
  actions: {
    display: 'flex',
    gap: 12,
    flexWrap: 'wrap',
    marginTop: 20,
  },
  primaryButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 48,
    padding: '0 20px',
    borderRadius: 16,
    backgroundColor: '#C9A14A',
    color: '#0F3D2E',
    textDecoration: 'none',
    fontWeight: 900,
  },
  secondaryButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 48,
    padding: '0 20px',
    borderRadius: 16,
    backgroundColor: '#ffffff',
    color: '#0F3D2E',
    border: '1px solid #E6D8BE',
    textDecoration: 'none',
    fontWeight: 900,
  },
});
